import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiRetakeConfig } from '@/data/landingConfig/landingAiRetakeConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiRetake } from './schemaObject';

interface Props {}
const AiRetake: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiRetake} />
			<LandingTemplate
				data={landingAiRetakeConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAiRetake()}
			/>
		</>
	);
};

export default AiRetake;
